document.addEventListener('DOMContentLoaded', function(e) {
  var map = L.map('map');

  L.tileLayer(mapSettings.host, {
    maxZoom: 19,
    attribution: mapSettings.copy
  }).addTo(map);

  map.attributionControl.setPrefix(false);

  map.setView(mapSettings.center, mapSettings.zoom);

  mapSettings.points.forEach(function(point) {
    var icon = new L.DivIcon({
      className: 'marker',
      html: '<img src="' + document.body.dataset.basepath + '/images/map-marker.svg" />'
    });

    L.marker([ point.lat, point.lng ], {icon: icon}).addTo(map);
  });
});
